<ngx-bootstrap-multiselect
    [settings]="settings"
    [texts]="texts"
    [options]="options"
    [(ngModel)]="idsAreas"
    (ngModelChange)="onChange()"
    [disabled]="disabled">
</ngx-bootstrap-multiselect>